import React from "react";
import { InspectionsTemplate } from "../../Templates/InspectionsTemplate";

export const Inspections = () => {
  return <InspectionsTemplate />;
};
